import { Capacitor } from "@capacitor/core";

/**
 * Solicita permisos de notificación, obtiene el FCM token y lo envía al backend.
 * Solo se ejecuta en plataforma nativa (Android/iOS).
 *
 * @param {import('axios').AxiosInstance} apiClient - Instancia de axios configurada con el token de auth.
 */
export async function registrarFCMToken(apiClient) {
    if (!Capacitor.isNativePlatform()) return;

    try {
        const { FirebaseMessaging } = await import("@capacitor-firebase/messaging");

        const { receive } = await FirebaseMessaging.requestPermissions();
        if (receive !== "granted") {
            console.warn("Permiso de notificaciones denegado");
            return;
        }

        const { token } = await FirebaseMessaging.getToken();
        if (!token) return;

        await apiClient.put("/perfil/", { fcm_token: token });
    } catch (err) {
        console.error("Error registrando FCM token:", err);
    }
}

/**
 * Registra el listener de notificaciones recibidas en primer plano.
 * Solo se ejecuta en plataforma nativa (Android/iOS).
 * Devuelve el handle del listener para poder eliminarlo al desmontar.
 *
 * @returns {Promise<{remove: () => void} | null>}
 */
export async function iniciarListenerNotificaciones() {
    if (!Capacitor.isNativePlatform()) return null;

    try {
        const { FirebaseMessaging } = await import("@capacitor-firebase/messaging");

        return FirebaseMessaging.addListener("notificationReceived", (event) => {
            const { title, body } = event.notification ?? {};
            console.log("Notificación recibida en primer plano:", title, body);

            if (window.showToast && body) {
                window.showToast(body);
            }
        });
    } catch (err) {
        console.error("Error iniciando listener de notificaciones:", err);
        return null;
    }
}
